import { reviveModel } from '~/shared/model'
import { isSerializable } from '~/shared/utils/guards'

// Без glob модель регистрируется только если её импортирует какой-нибудь сервис.
import.meta.glob('~/models/**/*.ts', { eager: true })

export default definePayloadPlugin(() => {
  definePayloadReducer('BaseModel', (value) => {
    if (isSerializable(value)) return value.serialize()
  })
  definePayloadReviver('BaseModel', value => reviveModel(value))
})
